import { render } from "./BillingSessionSuccess.vue?vue&type=template&id=0fa33374"
import script from "./BillingSessionSuccess.vue?vue&type=script&lang=js"
export * from "./BillingSessionSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__